/**
 * Company Types queries for TanStack Query (Vendor App)
 */

import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { queryKeys } from '../keys'
import { queryGet } from '../utils/request'

// Type definitions
export interface CompanyType {
  id: string // enum name, e.g. "retail"
  description: string
}

export interface CompanyTypeListParams {
  search?: string
  [key: string]: any
}

// Cache configuration
const CACHE_TIMES = {
  COMPANY_TYPES: 30 * 60 * 1000, // 30 minutes - company types rarely change
}

/**
 * QUERIES
 */

/**
 * Query hook to fetch all company types
 */
export const useCompanyTypesQuery = (params: MaybeRefOrGetter<CompanyTypeListParams> = {}) => {
  return useQuery({
    queryKey: computed(() => queryKeys.companyTypeList(toValue(params))),
    queryFn: async (): Promise<CompanyType[]> => {
      return queryGet<CompanyType[]>('/v2/company-types/')
    },
    staleTime: CACHE_TIMES.COMPANY_TYPES,
  })
}
